module.exports = __webpack_public_path__ + "static/media/design_session.7ac95dd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/elavon/src/design_session.jpg
// module id = 587
// module chunks = 0